<div class="nps w-100 h-100 p-1" [ngStyle]="{'border-radius': '10px'}">
    <div class="close-icon-container" *ngIf="showCloseIcon">
        <a id="close-dialog" class="close-nps" (click)="closeNps()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7322 6.9737L9.99967 8.7062L8.26717 6.9737C7.90967 6.6162 7.33217 6.6162 6.97467 6.9737C6.61717 7.3312 6.61717 7.9087 6.97467 8.2662L8.70717 9.9987L6.97467 11.7312C6.61717 12.0887 6.61717 12.6662 6.97467 13.0237C7.33217 13.3812 7.90967 13.3812 8.26717 13.0237L9.99967 11.2912L11.7322 13.0237C12.0897 13.3812 12.6672 13.3812 13.0247 13.0237C13.3822 12.6662 13.3822 12.0887 13.0247 11.7312L11.2922 9.9987L13.0247 8.2662C13.3822 7.9087 13.3822 7.3312 13.0247 6.9737C12.6672 6.62536 12.0805 6.62536 11.7322 6.9737ZM9.99967 0.832031C4.93051 0.832031 0.833008 4.92953 0.833008 9.9987C0.833008 15.0679 4.93051 19.1654 9.99967 19.1654C15.0688 19.1654 19.1663 15.0679 19.1663 9.9987C19.1663 4.92953 15.0688 0.832031 9.99967 0.832031ZM9.99967 17.332C5.95717 17.332 2.66634 14.0412 2.66634 9.9987C2.66634 5.9562 5.95717 2.66536 9.99967 2.66536C14.0422 2.66536 17.333 5.9562 17.333 9.9987C17.333 14.0412 14.0422 17.332 9.99967 17.332Z"
                    fill="#3A4A63" />
            </svg>
        </a>
    </div>
    <div class="container-fluid main-label">
        <div class="title-nps">
            {{ "nps.ESAT_P1" | translate }}
        </div>
    </div>
    <div class="ranking mt-4 pb-3">
        <div class="no label d-flex align-items-center d-none d-lg-block">
            {{ "nps.iDontThink" | translate }}
        </div>
        <div class="btns" *ngIf="mainQuestion">
            <div *ngFor="let item of mainQuestion.options"
                 type="button" class="btn btn-light ms-1"
                 (click)="selectOption(item)"
            >

                {{ item.option }}
            </div>
        </div>
        <div class="yes label d-flex align-items-center  d-none d-lg-block">
            {{ "nps.ofCourse" | translate }}
        </div>
    </div>
</div>



<div class=" flex justify-content-center nps-next-question-modal w-100">
    <p-dialog [(visible)]="npsModalVisible" [modal]="true" [style]="{ top: '200px'}" [draggable]="false"
        [resizable]="false" [closable]="false" position="top">
        <div class="dialog-rps-container">
            <a id="close-dialog-nps" class="close-dialog-nps" (click)="closeNpsModal()">
                <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
            </a>
            <p class="m-0">
                {{ "nps."+nextQuestion?.code | translate}}
            </p>
            <div class="card flex justify-content-center mt-2">
                <input [(ngModel)]="requestComment" type="text" pInputText
                    [placeholder]="placeholders[nextQuestion?.code]?.placeholder | translate" />
            </div>
            <div class="send-btn mt-3 mb-2 d-flex justify-content-center">
                <button type="button" class="btn btn-primary" (click)="sendNpsRequest()"
                    [disabled]="!(requestComment && requestComment!='') || loadingButton">
                    <div class="loading-btn" *ngIf="loadingButton">
                        <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                        <span>{{ 'nps.sendingResponse' | translate }}</span>
                    </div>
                    <span *ngIf="!loadingButton">{{ "nps.sendNpsBtn" | translate }}</span>
                </button>
            </div>
        </div>
    </p-dialog>
</div>


<div class="flex justify-content-center  nps-next-question-modal nps-success-modal">
    <p-dialog [(visible)]="successModal" [modal]="true" [style]="{ top: '200px' }" [draggable]="false"
        [resizable]="false" [closable]="false" position="top">
        <a id="nps-success-modal" class="close-dialog-nps" (click)="closeSuccessNpsModal()">
            <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
        </a>
        <div class="icon-container d-flex justify-content-center">
            <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.4997 0.333008C10.5397 0.333008 0.833008 10.0397 0.833008 21.9997C0.833008 33.9597 10.5397 43.6663 22.4997 43.6663C34.4597 43.6663 44.1663 33.9597 44.1663 21.9997C44.1663 10.0397 34.4597 0.333008 22.4997 0.333008ZM16.628 31.2947L8.84967 23.5163C8.00467 22.6713 8.00467 21.3063 8.84967 20.4613C9.69467 19.6163 11.0597 19.6163 11.9047 20.4613L18.1663 26.7013L33.073 11.7947C33.918 10.9497 35.283 10.9497 36.128 11.7947C36.973 12.6397 36.973 14.0047 36.128 14.8497L19.683 31.2947C18.8597 32.1397 17.473 32.1397 16.628 31.2947Z"
                    fill="#39A84A" />
            </svg>
        </div>
        <div class="title-container text-center">
            {{ placeholders[nextQuestion?.code]?.successTitle | translate }}
        </div>
        <div class="title-container text-center mt-3">
            {{ placeholders[nextQuestion?.code]?.successMessage | translate }}
        </div>
    </p-dialog>
</div>
